import { FC } from "react"
import { ApplicationFormList } from "../../../module/applicationForm/containers/list"

export const ApplicationFormAuthorityPattern: FC = () => <ApplicationFormList />
